import axios from "axios";
import { useEffect } from "react";
import queryString from "query-string";

import useTwitch from "./useTwitch.js";

const queryParams = queryString.parse(window.location.search);

const isDevelopment =
  !queryParams.state ||
  ["testing", "hosted_test", "in_review"].includes(queryParams.state);
const apiBaseUrl = isDevelopment
  ? process.env.DEV_EBS_API_BASE_URL
  : process.env.PROD_EBS_API_BASE_URL;

console.log("API Base URL:", apiBaseUrl);

const ebsApiClient = axios.create({
  baseURL: apiBaseUrl,
});

export default function useEbsApiClient() {
  const { auth } = useTwitch();

  useEffect(() => {
    if (auth.token) {
      ebsApiClient.defaults.headers = {
        Authorization: `Bearer ${auth.token}`,
      };
    }
  }, [auth]);

  return ebsApiClient;
}
